export default __webpack_public_path__ + "static/media/plus_icon_gray.6f40b9ac.svg";